import React from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import ViewRfi from "../components/ViewRfi";
import { actionType, purposeList } from "../utils/constant";
import { RfiProvider, useRfi } from "../contexts/RfiContext";
import NonDimentionalRFI from "../components/NonDimentionalRFI/NonDimentionalRFI";
import { useSelector } from "react-redux";
import { hasPermission } from "../utils/utilityFunctions";
import AppButton from "../components/AppButton";
import { useNavigate } from "react-router-dom";

const styles = {
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
  },
  nonPermissionContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
  },
};

// Inner component that uses the context
function RfiContent() {
  const { rfiDetails, loading, stagesLoading } = useRfi();
  const { profile } = useSelector((state) => state.profile);
  const navigate = useNavigate();

  if (loading || stagesLoading) {
    return (
      <Box sx={styles.loader}>
        <CircularProgress />
      </Box>
    );
  }

  if (!rfiDetails) {
    return (
      <Box sx={styles.nonPermissionContainer}>
        <Typography variant="h5">RFI Not Found</Typography>
        <Typography mb={3} variant="body1">
          The requested RFI could not be found.
        </Typography>
        <AppButton
          label="Back to Dashboard"
          onClick={() => navigate("/dashboard")}
        />
      </Box>
    );
  }

  if (!hasPermission(profile.permissions.actions, actionType.rfi_view)) {
    return (
      <Box sx={styles.nonPermissionContainer}>
        <Typography variant="h5" mb={3}>
          You don't have permission to view RFI.
        </Typography>
        <AppButton
          label="Back to Dashboard"
          onClick={() => navigate("/dashboard")}
        />
      </Box>
    );
  }

  // Render component based on purpose type
  const renderContentByPurpose = (purpose) => {
    if (purpose === purposeList.dimensional) {
      return <ViewRfi rfiDetails={rfiDetails} />;
    }
    return <NonDimentionalRFI rfiDetails={rfiDetails} />;
  };

  return <Box>{renderContentByPurpose(rfiDetails?.purpose?.purpose_name)}</Box>;
}

// Outer wrapper component that provides the context
export default function Rfi() {
  return (
    <RfiProvider>
      <RfiContent />
    </RfiProvider>
  );
}
